import React from "react";
import { ANALYTICS_CATEGORY } from "../../../index.content";
import TrackedLink from "../../../../../Analytics/TrackedLink";
import Facebook from "./Facebook";
import Youtube from "./Youtube";
import "./index.scss";

const SOCIAL_DATA = [
  {
    name: "youtube",
    url: "https://www.youtube.com/channel/UC-rV0wnbUUx8grz1Awtlt-A",
    icon: <Youtube />,
  },
  {
    name: "facebook",
    url: "https://www.facebook.com/amzscoutcrew",
    icon: <Facebook />,
  },
];

const Social = () => {
  return (
    <div className="GCL-F-B-US-S">
      {SOCIAL_DATA.map(({ url, name, icon }, i) => (
        <TrackedLink
          key={i}
          target
          path={url}
          category={ANALYTICS_CATEGORY}
          action={name}
          rel="nofollow"
          classes={`GCL-F-B-US-S__${name}`}
        >
          {icon}
        </TrackedLink>
      ))}
    </div>
  );
};
export default Social;
